import { TableClusterNameCell } from 'components/DataVis/DataTable/styledComponents';
import { TikTokNameBodyCol } from 'components/TikTokTable';
import Tooltip from 'components/Tooltip';
import { getTooltipContent } from './utils';
import { nameFormatCell } from 'components/DataVis/DataTable/utils';
import { relatedHashtagCell as relatedCategoriesCell } from 'components/DataVis/PopularityIndexRelatedEntitiesTable/PopularityIndexRelatedEntitiesSectionTable';
import { relatedHashtagCell } from 'components/DataVis/RelatedHashtagsTable/styledComponents';
import { useTheme } from 'styled-components';

const NameCellWithTooltip = ({ row, value }) => {
    const theme = useTheme();
    const isHashtagData =
        row.type === 'hashtag' || row.type === 'instagram-hashtag';
    const isRelatedHashtagData =
        row.type === 'related-hashtag' ||
        row.type === 'instagram-related-hashtag';
    const trendDimension = row.brand ? 'brands' : 'categories';
    const isRelatedCategoryData = row.type === 'related-category';
    const isAffinityData = row.type === 'affinity';

    const tooltipContent = getTooltipContent(row);
    const css = `transition: color 0.3s ease 0.9s; &:hover { color: ${theme.purple_500}; }`;

    if (isHashtagData) {
        return (
            <Tooltip content={tooltipContent}>
                <div css="width 100%;">
                    <TikTokNameBodyCol
                        row={row}
                        isHashtagData={isHashtagData}
                        type={trendDimension}
                        $hashtagTextCss={css}
                    />
                </div>
            </Tooltip>
        );
    }

    if (isRelatedHashtagData) {
        if (!row.relatedName) {
            row.relatedName = row.categoryId ? 'Category' : 'Brand';
        }
        return (
            <Tooltip content={tooltipContent}>
                {relatedHashtagCell({
                    value,
                    row,
                    css,
                })}
            </Tooltip>
        );
    }

    if (isRelatedCategoryData) {
        if (!row.relatedName) {
            row.relatedName = row.categoryId ? 'Category' : 'Brand';
        }
        return (
            <Tooltip content={tooltipContent}>
                {relatedCategoriesCell({
                    value,
                    row,
                    css,
                })}
            </Tooltip>
        );
    }

    if (isAffinityData) {
        return (
            <TableClusterNameCell
                cluster={row.cluster}
                fetching={row.fetchingData}
                name={value}
                relatedName={
                    row.parent_trend_name ||
                    (row.categoryId ? 'Category' : 'Brand')
                }
                nameToolTipContent={tooltipContent}
                nameCss={css}
            />
        );
    }

    return nameFormatCell({ value, row });
};

export default NameCellWithTooltip;
